import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { mdiChevronDown } from '@mdi/js';
import { AccordionHeaderButton, AccordionHeaderIconStyled, AccordionHeaderText } from './styles';
const AccordionHeader = ({
  accordionId,
  children,
  isOpen,
  onClick,
  renderHeader,
  alignText = 'left',
  ...props
}) => /*#__PURE__*/React.createElement(AccordionHeaderButton, _extends({
  type: "button",
  "aria-expanded": isOpen,
  "aria-controls": accordionId,
  id: `${accordionId}Header`,
  onClick: onClick,
  "data-auto": "accordionHeaderButton"
}, props), renderHeader ? renderHeader({
  isOpen
}) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccordionHeaderText, {
  breakWord: true,
  color: "content",
  bold: true,
  align: alignText
}, children), /*#__PURE__*/React.createElement(AccordionHeaderIconStyled, {
  "aria-hidden": "true",
  color: "content",
  icon: mdiChevronDown,
  size: 1,
  $rotate: isOpen
})));
export default AccordionHeader;
//# sourceMappingURL=AccordionHeader.js.map